export default {"src":"/_next/static/media/logo-likelion.e77f66b1.svg","height":120,"width":243,"blurWidth":0,"blurHeight":0};